import { styled } from "@mui/material/styles";
import { useCache } from "designSystem/hooks";
import { Grid, Text } from "designSystem/index";
import ContextConstructor from "csi/def/Context";
import Spec from "csi/core/Spec";
import StoreCache from "csi/store/Cache";
import { C8Node, ICache } from "csi/typings";
import React, { FunctionComponent } from "react";
import SpecComponent from "./SpecComponent";

const PREFIX = "GalleryAttributes";

const classes = {
	item: `${PREFIX}item`,
	label: `${PREFIX}label`,
};

const StyledGrid = styled(Grid)((
	{
		theme,
	},
) => ({
	[`& .${classes.item}`]: {
		"& .attrBoolean": {
			position: "relative",
			top: -1,
		},
		display: "-webkit-box",
		overflow: "hidden",
		WebkitLineClamp: 3,
		WebkitBoxOrient: "vertical",
	},

	[`& .${classes.label}`]: {
		color: theme.palette.grey[900],
		marginRight: theme.spacing(1),
	},
}));

const _storeCache = new StoreCache();

export interface GalleryAttributesProps {
	/** cache containing node and any dependent nodes needed for rendering */
	cache?: ICache;

	/** node containing data to render */
	node: C8Node;

	/** indicates if attribute labels should be shown */
	showLabels?: boolean;

	/** specs to render */
	specs: Spec[];
}

const GalleryAttributes: FunctionComponent<GalleryAttributesProps> = (props) => {
	const { cache, node, showLabels, specs } = props;
	const resolvedCache = cache || useCache();

	const _ctx = new ContextConstructor(null, _storeCache, node.$URL);
	_ctx.bForceBrowse = false;

	// hack to speed up transition to old cache and context
	_storeCache.mirrorCache = resolvedCache;

	return (
		<StyledGrid
			container
			direction="column"
			spacing={2}
		>
			{
				specs.map((spec) => (
					<Grid
						className={classes.item}
						item
						key={spec.key.toString()}
					>
						{showLabels && (
							<Text
								className={classes.label}
								text={`${spec.name}:`}
								variant="subtitle1"
							/>
						)}
						<SpecComponent ctx={_ctx} spec={spec} />
					</Grid>
				))
			}
		</StyledGrid>
	);
};

export default GalleryAttributes;
